const colors = {
  black: "#000",
  white: "#fff",
  cyan: {
    // 50: "#66EEFF",
    // 100: "#66EEFF",
    // 200: "#66EEFF",
    // 300: "#25CADE",
    // 400: "#00ACC1",
    // 500: "#1F94A3",
    // 600: "#2B7781",
    // 700: "#2B7781",
    // 800: "#2B7781",
    // 900: "#2B7781",

    50: "#ecfeff",
    100: "#cffafe",
    200: "#a5f3fc",
    300: "#67e8f9",
    400: "#22d3ee",
    500: "#06b6d4",
    600: "#0891b2",
    700: "#0e7490",
    800: "#155e75",
    900: "#164e63",
  },
  red: {
    50: "#FF988A",
    100: "#FF988A",
    200: "#FF988A",
    300: "#EE7564",
    400: "#EC3F3F",
    500: "#E21111",
    600: "#BA0000",
    700: "#BA0000",
    800: "#BA0000",
    900: "#BA0000",
  },
  yellow: {
    50: "#FFD67D",
    100: "#FFD67D",
    200: "#FFD67D",
    300: "#FFC23D",
    400: "#FFAF00",
    500: "#FF8A00",
    600: "#FF7A00",
    700: "#FF7A00",
    800: "#FF7A00",
    900: "#FF7A00",
  },
  green: {
    50: "#64F7AE",
    100: "#64F7AE",
    200: "#64F7AE",
    300: "#29E287",
    400: "#0FC169",
    500: "#06A456",
    600: "#017B3F",
    700: "#017B3F",
    800: "#017B3F",
    900: "#017B3F",
  },
  teal: {
    50: "#CDDAD9",
    100: "#9BB4B3",
    200: "#6A8F8E",
    300: "#386968",
    400: "#1F5755",
    500: "#064442",
    600: "#053D3B",
    700: "#053635",
    800: "#042928",
    900: "#032221",
  },
  gray: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#4b5563",
    700: "#374151",
    800: "#1f2937",
    900: "#111827",
    // 50: "#f9fafb",
    // 100: "#EBEBEB",
    // 200: "#DDDDDD",
    // 300: "#C4C4C4",
    // 400: "#B3B3B3",
    // 500: "#979797",
    // 600: "#858585",
    // 700: "#626262",
    // 800: "#4B4B4B",
    // 900: "#2B2B2B",
  },
};

export default colors;
